import { CanvasPromptEditor } from "./InlineTextEditor.js";
import { promptToPlainText } from "@seedance/contracts";
import { memo } from "react";
import { Handle, Position, type NodeProps } from "@xyflow/react";
import { canvasCopy } from "../../copy/zh-CN.js";
import type { ScriptFlowNode } from "./node-types.js";
import { useMeasuredHandles } from "./useMeasuredHandles.js";

export const ScriptPlaceholderNode = memo(function ScriptPlaceholderNode({
  id,
  data,
  selected
}: NodeProps<ScriptFlowNode>) {
  useMeasuredHandles(id, data.refreshHandles);
  return (
    <article className={`asset-node asset-node--script${selected ? " asset-node--selected" : ""}`}>
      <Handle type="target" position={Position.Left} />
      <header><span>{canvasCopy.manualScript}</span><strong>{promptToPlainText(data.canvasNode.title) || canvasCopy.manualScript}</strong></header>
      {data.document && data.onDocumentChange ? <>
        <CanvasPromptEditor document={data.document} source={{nodeId:id,field:"title",inputEdgeId:null}} onChange={data.onDocumentChange} ariaLabel="脚本标题" maxLength={160} {...(data.onUndo ? {onUndo:data.onUndo} : {})} {...(data.onRedo ? {onRedo:data.onRedo} : {})} />
        <CanvasPromptEditor document={data.document} source={{nodeId:id,field:"synopsis",inputEdgeId:null}} onChange={data.onDocumentChange} ariaLabel="脚本梗概" maxLength={20_000} {...(data.onUndo ? {onUndo:data.onUndo} : {})} {...(data.onRedo ? {onRedo:data.onRedo} : {})} />
      </> : <p>{promptToPlainText(data.canvasNode.synopsis) || canvasCopy.emptyScript}</p>}
      <Handle type="source" position={Position.Right} />
    </article>
  );
});
